// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expansion-panel-header {
    z-index: 1000;
    font-weight: bold;
    color: var(--branco-padrao);
    cursor: pointer;
    border: none;
    width: 100%;
    border-radius: 8px 8px 0 0;
    transition: all .3s;
    display: flex;
    flex-direction: column;
    align-items: space-between;
}

.expansion-panel-header button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    width: 100%;
    padding-left: 1rem;
    font-size: .95rem;
}

.icone-expansion-paineis {
    font-size: 2.1rem;
}

.expansion-panel-header button span {
    margin: .3rem 0 0 .1rem;
}

.naoEstaExpandido {
    border-radius: 8px;
}

/* Container principal de todos os chamados (container de quando está expandido) */
.expansion-panel-content {
    background-color: var(--branco-padrao);
    box-shadow: 0 5px 10px 0px rgba(0, 0, 0, .3);
    border-radius: 0px 0px 8px 8px;
    padding: 0 .2rem;
    max-height: 0;
    opacity: 0;
    overflow: hidden;
}

/* Config e css da lista, lista completa também, quando expandido */
.expansion-panel-content.expanded {
    padding: .5rem 1rem 1rem 1rem;
    max-height: -moz-fit-content;
    max-height: fit-content;
    opacity: 1;
}

.expansion-panel-content ul {
    display: flex;
    flex-direction: column;
    gap: .1rem;
}

/* Definindo as cores com base no tipoListaChamado */
button.tipo1 {
    background-color: var(--cinza-em-aberto);
}

button.tipo1.sem-chamados, button.tipo1.sem-chamados:hover {
    cursor: default;
    color: var(--texto-cinza);
    background-color: var(--cinza-desativado);
}

button.tipo2 {
    background-color: var(--azul-dixi);
}

button.tipo2.sem-chamados, button.tipo2.sem-chamados:hover {
    cursor: default;
    color: var(--texto-azul);
    background-color: var(--azul-desativado);
}

button.tipo3 {
    background-color: var(--aguardando-resposta-color);
}

button.tipo3.sem-chamados, button.tipo3.sem-chamados:hover {
    cursor: default;
    color: var(--texto-laranja);
    background-color: var(--laranja-desativado);
}

button.tipo4 {
    background-color: var(--finalizado-color);
}

button.tipo4.sem-chamados, button.tipo4.sem-chamados:hover {
    cursor: default;
    color: var(--texto-verde);
    background-color: var(--verde-desativado);
}

button.tipo7 {
    background-color: var(--em-analise-color);
}

button.tipo7.sem-chamados, button.tipo7.sem-chamados:hover {
    cursor: default;
    color: var(--texto-em-analise);
    background-color: var(--em-analise-desativado);
}

button.tipo8 {
    background-color: var(--congelado-color);
}

button.tipo8.sem-chamados, button.tipo8.sem-chamados:hover {
    cursor: default;
    color: var(--texto-congelado);
    background-color: var(--congelado-desativado);
}

.expansion-panel-header.tipo1:hover {
    background-color: var(--cinza-padrao2);
}

.expansion-panel-header.tipo2:hover {
    background-color: var(--botao-hover);
}

.expansion-panel-header.tipo3:hover {
    background-color: var(--aguardando-resposta-color-hover);
}

.expansion-panel-header.tipo4:hover {
    background-color: var(--finalizado-color-hover);
}

.expansion-panel-header.tipo7:hover {
    background-color: var(--em-analise-color-hover);
}

.expansion-panel-header.tipo8:hover {
    background-color: var(--congelado-color-hover);
}

.icone-expansion-paineis.sem-chamados {
    opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/PainelExpansivelChamado/PainelExpansivelChamado.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,2BAA2B;IAC3B,eAAe;IACf,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA,kFAAkF;AAClF;IACI,sCAAsC;IACtC,4CAA4C;IAC5C,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,gBAAgB;AACpB;;AAEA,mEAAmE;AACnE;IACI,6BAA6B;IAC7B,4BAAuB;IAAvB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA,oDAAoD;AACpD;IACI,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,8CAA8C;AAClD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,6CAA6C;AACjD;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,UAAU;AACd","sourcesContent":[".expansion-panel-header {\n    z-index: 1000;\n    font-weight: bold;\n    color: var(--branco-padrao);\n    cursor: pointer;\n    border: none;\n    width: 100%;\n    border-radius: 8px 8px 0 0;\n    transition: all .3s;\n    display: flex;\n    flex-direction: column;\n    align-items: space-between;\n}\n\n.expansion-panel-header button {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: start;\n    width: 100%;\n    padding-left: 1rem;\n    font-size: .95rem;\n}\n\n.icone-expansion-paineis {\n    font-size: 2.1rem;\n}\n\n.expansion-panel-header button span {\n    margin: .3rem 0 0 .1rem;\n}\n\n.naoEstaExpandido {\n    border-radius: 8px;\n}\n\n/* Container principal de todos os chamados (container de quando está expandido) */\n.expansion-panel-content {\n    background-color: var(--branco-padrao);\n    box-shadow: 0 5px 10px 0px rgba(0, 0, 0, .3);\n    border-radius: 0px 0px 8px 8px;\n    padding: 0 .2rem;\n    max-height: 0;\n    opacity: 0;\n    overflow: hidden;\n}\n\n/* Config e css da lista, lista completa também, quando expandido */\n.expansion-panel-content.expanded {\n    padding: .5rem 1rem 1rem 1rem;\n    max-height: fit-content;\n    opacity: 1;\n}\n\n.expansion-panel-content ul {\n    display: flex;\n    flex-direction: column;\n    gap: .1rem;\n}\n\n/* Definindo as cores com base no tipoListaChamado */\nbutton.tipo1 {\n    background-color: var(--cinza-em-aberto);\n}\n\nbutton.tipo1.sem-chamados, button.tipo1.sem-chamados:hover {\n    cursor: default;\n    color: var(--texto-cinza);\n    background-color: var(--cinza-desativado);\n}\n\nbutton.tipo2 {\n    background-color: var(--azul-dixi);\n}\n\nbutton.tipo2.sem-chamados, button.tipo2.sem-chamados:hover {\n    cursor: default;\n    color: var(--texto-azul);\n    background-color: var(--azul-desativado);\n}\n\nbutton.tipo3 {\n    background-color: var(--aguardando-resposta-color);\n}\n\nbutton.tipo3.sem-chamados, button.tipo3.sem-chamados:hover {\n    cursor: default;\n    color: var(--texto-laranja);\n    background-color: var(--laranja-desativado);\n}\n\nbutton.tipo4 {\n    background-color: var(--finalizado-color);\n}\n\nbutton.tipo4.sem-chamados, button.tipo4.sem-chamados:hover {\n    cursor: default;\n    color: var(--texto-verde);\n    background-color: var(--verde-desativado);\n}\n\nbutton.tipo7 {\n    background-color: var(--em-analise-color);\n}\n\nbutton.tipo7.sem-chamados, button.tipo7.sem-chamados:hover {\n    cursor: default;\n    color: var(--texto-em-analise);\n    background-color: var(--em-analise-desativado);\n}\n\nbutton.tipo8 {\n    background-color: var(--congelado-color);\n}\n\nbutton.tipo8.sem-chamados, button.tipo8.sem-chamados:hover {\n    cursor: default;\n    color: var(--texto-congelado);\n    background-color: var(--congelado-desativado);\n}\n\n.expansion-panel-header.tipo1:hover {\n    background-color: var(--cinza-padrao2);\n}\n\n.expansion-panel-header.tipo2:hover {\n    background-color: var(--botao-hover);\n}\n\n.expansion-panel-header.tipo3:hover {\n    background-color: var(--aguardando-resposta-color-hover);\n}\n\n.expansion-panel-header.tipo4:hover {\n    background-color: var(--finalizado-color-hover);\n}\n\n.expansion-panel-header.tipo7:hover {\n    background-color: var(--em-analise-color-hover);\n}\n\n.expansion-panel-header.tipo8:hover {\n    background-color: var(--congelado-color-hover);\n}\n\n.icone-expansion-paineis.sem-chamados {\n    opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
